import { ContentState } from 'draft-js';
import React, { FC } from 'react';
import { useStyles } from './styles';

interface LinkProps {
  contentState: ContentState;
  entityKey: string;
}
export const Link: FC<LinkProps> = ({ entityKey, children, contentState }) => {
  const { url } = contentState.getEntity(entityKey).getData();
  const classes = useStyles();

  return (
    <a
      className={classes.link}
      href={url}
      title={url}
      onClick={(e) => {
        e.stopPropagation();
        window.open(url);
      }}
    >
      {children}
    </a>
  );
};
